<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>


      <v-toolbar-title class="pageTitle">
        Inventurtage bearbeiten
      </v-toolbar-title>
    </v-toolbar>
    <v-divider class="headerDivider"/>
    <div class="contentWrapper checkoutContent" ref="contentWrapper" id="contentWrapper">
      <v-card class="stepperSearchWrapper pb-10">
        <v-container class="deliveryDays__container">
          <span>Kundenauswahl</span>

          <v-autocomplete class="searchCbx"
                          append-icon=""
                          outlined
                          dense
                          hide-details
                          placeholder="Kundenname..."
                          :items="customers"
                          item-text="marketName"
                          item-value="id"
                          single
                          v-model="selectedCustomer"
                          no-data-text="Keine Eintrgäge gefunden..."
          >
            <template v-slot:item="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-item-content v-text="data.item"></v-list-item-content>
              </template>
              <template v-else>
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.marketName"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.customerNo"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </template>

          </v-autocomplete>

          <span>Inventurzeitraum</span>
          <v-text-field
            class="searchCbx inventory-date__sel"
            append-icon=""
            placeholder="Inventurzeitraum..."
            outlined
            dense
            readonly
            hide-details
            v-model="dateRangeText"
          >
            t

            <template v-slot:append-outer>
              <template>
                <v-dialog
                    ref="dialog"
                    v-model="modal"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs"
                            v-on="on"
                            class="deliveryDays__chip-day-icon"
                    >
                      mdi-calendar
                    </v-icon>
                  </template>
                  <v-date-picker
                      class="deliveryDatePicker"
                      locale="de"
                      :first-day-of-week="1"
                      range
                      multiple
                      v-model="date"
                      :selected-items-text="date !== null ? (date.length > 1 ? dateParse(date[0])+' bis '+dateParse(date[1]) :  dateParse(date[0])) : ''"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="modal = false"
                    >
                      Schließen
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </template>
            </template>
          </v-text-field>
        </v-container>

        <v-container v-if="this.foundFuturePeriods !== null && this.foundFuturePeriods.length > 0">
          <span>Geplante bzw. laufende Inventuren</span>
          <div v-for="(futurePeriod, index) in this.foundFuturePeriods" :key="index" class="planned-inventories_container">
            <div class="period">{{ dateParse(futurePeriod.begins_at) }} bis {{ dateParse(futurePeriod.ends_at) }}</div>

            <v-btn class="btn" @click="deleteInventoryPeriod(futurePeriod, index)">
              <v-icon>
                mdi-minus
              </v-icon>
            </v-btn>
          </div>
        </v-container>

        <v-btn class="apply-inventory-period_btn" @click="applyInventoryPeriod">
          Speichern
        </v-btn>
      </v-card>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import axios from 'axios'
import router from "@/router";

export default {
  name: "editInventoryDays",

  data() {
    return {
      isLoading: true,
      selectedCustomer: null,
      date: null,
      modal: false,
      period: [],
      foundFuturePeriods: null,

      dateRules: [
        v => /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/.test(v)
      ],

      customers: [],
    }
  },

  methods: {
    ...mapMutations({
      setHeaderVisibility: 'setHeaderVisibility'
    }),

    goBack() {
      router.go(-1)
    },

    deleteInventoryPeriod(period, index) {
      let params = {
        id: period.id
      }

      this.foundFuturePeriods.splice(index, 1)
      axios.post('api/deletePeriod', params)
    },

    applyInventoryPeriod() {
      let customer = this.customers[this.selectedCustomer -1]

      let params = {
        customer_id: customer['customer_id'],
        date: this.date
      }


      if(this.foundFuturePeriods !== null) {
        this.foundFuturePeriods.push({begins_at: this.date[0], ends_at:this.date[1]})
      }
      else {
        this.foundFuturePeriods = [{begins_at: this.date[0], ends_at:this.date[1]}]
      }

      axios.post('api/setInventoryPeriod', params)

    },

    dateParse(val) {

      let year = val.substring(0,4)
      let month = val.substring(5,7)
      let day = val.substring(8,10)

      return day+'.'+month+'.'+year
    },

    removeDate(item) {
      console.log(item)
    },
  },

  computed: {
    dateRangeText() {
      if(this.date !== null) {
        if(this.date.length === 1) {
          return this.dateParse(this.date[0])
        }
        else {
          return this.dateParse(this.date[0])+' bis '+this.dateParse(this.date[1])
        }
      }
      else {
        return ''
      }
    },

  },

  created() {
    this.setHeaderVisibility(false)

    axios.post('api/searchCustomer')
        .then((result) => {
          this.customers = result.data
        })
  },

  watch: {
    selectedCustomer: {
      handler(state) {
        this.date = null
        let customer = this.customers[state -1]
        let params = {
          customer_id: customer.customer_id
        }
        axios.post('api/getFuturePeriods', params).then((res) => {
          this.foundFuturePeriods = res.data
        })
      }
    }
  }

}
</script>

<style>
  .inventory-date__sel .v-text-field__slot {
    font-size: 16px!important;
  }

  .apply-inventory-period_btn {
    background-color: var(--igros-red)!important;
    position: absolute;
    bottom: -22px;
    right: 20px;
  }

  .planned-inventories_container {
    display: grid;
    grid-template-columns: auto auto;
    text-align: center;
    align-items: center;
    width: 340px;
    margin-right: auto;
    margin-left: auto;
    height: 50px;
  }

  .planned-inventories_container .period {
    grid-column-start: 1;
    grid-column-end: 1;
    display: inline-flex;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }

  .planned-inventories_container .btn {
    background-color: var(--igros-red)!important;
    height: 30px!important;
    min-height: 30px!important;
    width: 30px;
    min-width: 30px!important;
    grid-column-start: 2;
    grid-column-end: 2;
    margin-left: auto;
    margin-right: auto;
    display: inline-flex;
    align-items: center;
  }
</style>
